
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProtocolVersion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProtocolVersion"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amendmentNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amendmentDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"versionName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"consentRequired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"changeLog"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":129}};
    doc.loc.source = {"body":"fragment ProtocolVersion on ProtocolVersion {\n\tid,\n\tamendmentNumber,\n\tamendmentDate,\n\tversionName,\n\tconsentRequired,\n\tchangeLog\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
